import { useNavigate } from 'react-router-dom';
import {
  ArrowRight,
  Ban,
  Crown,
  FileText,
  LifeBuoy,
  LogOut,
  MessageCircle,
  Star
} from '../../components/ui/icons';
import { APP_STORE_URL } from '../../lib/appStore';
import { ActionRow, Divider, Group, SectionLabel } from './SettingsRows';
import { APP_VERSION, FEEDBACK_EMAIL, HELP_URL, TERMS_URL } from './constants';

export function PrivacySection({
  blockedCount,
  onShowBlocked
}: {
  blockedCount: number;
  onShowBlocked: () => void;
}) {
  return (
    <>
      <SectionLabel>Privacy &amp; safety</SectionLabel>
      <Group>
        <ActionRow
          icon={<Ban width={16} height={16} strokeWidth={2} className="text-white" />}
          iconBg="#E2541F"
          label="Blocked accounts"
          onClick={onShowBlocked}
          value={blockedCount > 0 ? String(blockedCount) : 'None'}
        />
      </Group>
    </>
  );
}

export function GoProBanner() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/pro')}
      className="tap relative mt-[22px] flex w-full items-center gap-[14px] overflow-hidden rounded-[22px] bg-[linear-gradient(135deg,#FCDE7C_0%,#E3A82B_100%)] p-[17px] text-left shadow-[0_18px_34px_-18px_rgba(180,130,30,0.6)]"
    >
      <div className="pointer-events-none absolute -right-8 -top-10 h-[160px] w-[160px] rounded-full bg-[radial-gradient(circle,rgba(255,255,255,0.35),transparent_70%)]" />
      <div className="relative grid h-11 w-11 shrink-0 place-items-center rounded-[13px] border border-[#7A5410]/20 bg-[#7A5410]/16">
        <Crown width={24} height={24} strokeWidth={2} style={{ color: '#7A5410' }} />
      </div>
      <div className="relative flex-1">
        <div className="text-[16px] font-extrabold tracking-[-0.02em] text-[#5E3F09]">Go Pro</div>
        <div className="mt-[2px] text-[12.5px] font-semibold leading-[1.25] text-[#7A5410]">
          Private leagues, deep stats &amp; an ad-free season.
        </div>
      </div>
      <div className="relative flex shrink-0 items-center gap-[5px] rounded-full bg-night px-[14px] py-[9px]">
        <span className="text-[13px] font-extrabold text-white">Join waitlist</span>
        <ArrowRight width={13} height={13} strokeWidth={2.8} className="text-white" />
      </div>
    </button>
  );
}

export function SupportSection() {
  return (
    <>
      <SectionLabel>Support</SectionLabel>
      <Group>
        <ActionRow
          icon={<LifeBuoy width={16} height={16} strokeWidth={2} className="text-white" />}
          iconBg="#3B7DE0"
          label="Help centre"
          onClick={() => window.open(HELP_URL, '_blank', 'noopener')}
        />
        <Divider />
        <ActionRow
          icon={<MessageCircle width={16} height={16} strokeWidth={2} className="text-white" />}
          iconBg="#24C56A"
          label="Send feedback"
          onClick={() => {
            window.location.href = `mailto:${FEEDBACK_EMAIL}?subject=HeadToHead%20feedback`;
          }}
        />
        <Divider />
        <ActionRow
          iconNode={
            <span className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-[9px] bg-gradient-to-br from-gold-top to-gold-bottom">
              <Star width={16} height={16} strokeWidth={1.6} className="fill-white text-white" />
            </span>
          }
          label="Rate HeadToHead"
          onClick={() => window.open(APP_STORE_URL, '_blank', 'noopener')}
        />
        <Divider />
        <ActionRow
          icon={<FileText width={16} height={16} strokeWidth={2} className="text-white" />}
          iconBg="#6E6E73"
          label="Terms & privacy"
          onClick={() => window.open(TERMS_URL, '_blank', 'noopener')}
        />
      </Group>
    </>
  );
}

export function SettingsFooter({
  onDeleteAccount,
  onSignOut
}: {
  onDeleteAccount: () => void;
  onSignOut: () => void;
}) {
  return (
    <>
      <button
        type="button"
        onClick={onSignOut}
        className="tap mt-6 flex w-full items-center justify-center gap-[9px] rounded-[20px] border border-black/5 bg-card py-[15px] shadow-tile"
      >
        <LogOut width={18} height={18} strokeWidth={2.2} className="text-danger" />
        <span className="text-[15px] font-bold tracking-snug text-danger">Sign out</span>
      </button>

      <div className="py-6 text-center">
        <button
          type="button"
          onClick={onDeleteAccount}
          className="tap p-[6px] text-[13px] font-semibold text-ink4"
        >
          Delete account
        </button>
        <div className="mt-2 text-[11px] font-medium text-ink4">HeadToHead · {APP_VERSION}</div>
      </div>
    </>
  );
}
